export default function Avatar({ initials, seed = 0 }) {
  const colors = [
    "from-purple-400 to-purple-600",
    "from-pink-400 to-pink-600",
    "from-blue-400 to-blue-600",
  ];

  return (
    <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${colors[seed % 3]} flex items-center justify-center text-white font-bold`}>
      {initials}
    </div>
  );
}